import { Group } from '@components/layout';
import { DateDisplay, Typography } from '@components/typography';
import { Stack, useTheme } from '@mui/material';
import { differenceInMinutes } from 'date-fns';

type JobsConfigurationsPreviewInfoProps = {
  name: string;
  createdAt: string;
  updatedAt: string;
};

export const JobsConfigurationsPreviewInfo = ({
  name,
  updatedAt,
  createdAt,
}: JobsConfigurationsPreviewInfoProps) => {
  const { palette } = useTheme();
  const showLastRun =
    updatedAt && createdAt && differenceInMinutes(new Date(updatedAt), new Date(createdAt)) > 2;
  return (
    <Stack flexWrap="wrap" overflow="hidden" gap={1}>
      <Typography variant="subtitle2" color={palette.text.paper} handleOverFlow>
        {name || '-'}
      </Typography>
      <Group gap={1}>
        <Typography variant="caption2" fitContent color={palette.text.paper}>
          Published:
        </Typography>
        <DateDisplay date={createdAt} color={palette.text.light} variant="caption2" fitContent />
      </Group>
      {showLastRun && (
        <Group gap={1}>
          <Typography variant="caption2" fitContent color={palette.text.paper}>
            Last run:
          </Typography>
          <DateDisplay date={updatedAt} color={palette.text.light} variant="caption2" fitContent />
        </Group>
      )}
    </Stack>
  );
};
